import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'

const getTranslateMasterFilters = function () {
  return {
    name: { label: i18n.t('app.name'), value: '' },
    email: { label: i18n.tc('users.email', 1), value: '' },
  }
}
const getColumns = function getColumns () {
  return [
    { field: 'idUsuario', width: '100px', title: i18n.t('app.id'), hidden: true, columnMenu: 'myTemplate', locked: false },
    { field: 'Usuario', title: i18n.t('app.name'), hidden: false, columnMenu: 'myTemplate', locked: false },
    { field: 'Email', title: i18n.tc('users.email', 1), columnMenu: 'myTemplate', locked: false },
    { field: 'Grupos', title: i18n.t('groups.header'), hidden: false, cell: 'tagsTemplate', columnMenu: 'myTemplate', locked: false }
  ]
}

const getDefaultState = () => {
  return {
    notificationsNumber: {},
  }
}
const customState = getDefaultState()
const customGetters = {
  getNotificationsNumber: state => state.notificationsNumber,
}
const customMutations = {
  setNotificationsNumber (state, notificationsNumber) {
    state.notificationsNumber = notificationsNumber
  },
  resetNotificationsNumber (state) {
    state.notificationsNumber = {}
  },
}
const mystore = parent({ selectable: true, navigate: false, customState, customGetters, customMutations, namespaced: true, getTranslateColumns: getColumns, getTranslateMasterFilters })

export default mystore
